// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5125f7fa","455":"c0efee24"}[chunkId] + ".chunk.js";
};